<template>
    <fragment v-if="isDevMode">
        <div class="login-page">
            <div class="form">
                <form class="login-form" @submit.prevent>
                    <!-- 200618추가 S -->
                    <dl class="notice_msg">
                        <dt>NOTICE</dt>
                        <dd>
                            Not available when upgrading the server<br>
                            <span>Mon.~Fri., KRT : 10:00~11:00 / 17:00~18:00</span><br>
                        </dd>
                    </dl>
                    <!-- 200618추가 E -->
                    <p class="message">System</p>
                    <select id="loginSystem" name="loginSystem" v-model="loginSystem">
                        <option disabled value="">Please select a system</option>
                        <option value="WLDPTM">SKP</option>
                        <option value="SUPPORT">SUPPORT</option>
                        <option value="GSPN">GSPN</option>
<!--                         <option value="CS">CS Portal</option> -->
                        <!--
                        <option value="SCMS">SCMS</option>
                        <option value="CS">CS</option>
                        -->
                    </select>
                    <p class="message">Login Information</p>
                    <input
                        type="text"
                        name="loginIdManual"
                        placeholder="SKP Login ID"
                        v-model="loginId"
                        required
                        autofocus
                    />

                    <select
                        id="loginId"
                        name="loginId"
                        @change="loginIdChange($event)"
                        v-if="localAutoLogin('select')"
                    >
                        <option disabled value="">Select One</option>
                        <option value="">[] </option>
                        <option disabled value="">HHP</option>
                        <option value="">[] </option>
                        <option disabled value="">※ Subsidiary ※</option>
                        <option value="">[] </option>
                        <option value="">[] </option>
                        <option value="">[] </option>
                        <option value="">[] </option>
                        <option value="">[] </option>
                        <option disabled value="">※ ASC ※</option>
                        <option value="">[] </option>
                        <option value="">[] </option>
                        <option value="">[] </option>
                    </select>

                    <input
                        id="loginPwd"
                        name="loginPwd"
                        type="password"
                        placeholder="password"
                        v-model="loginPwd"
                        @keydown.enter="handleSubmit"
                    />
                    <input id="loginType" name="loginType" type="hidden" v-model="loginType" />
                    <input id="loadMenuKind" name="loadMenuKind" type="hidden" v-model="loadMenuKind" />
                    <button type="submit" @click="handleSubmit">LOGIN</button>
                </form>
            </div>
        </div>
    </fragment>
</template>

<script>

import Vue                                  from 'vue';
import { mapActions, mapGetters }           from 'vuex';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import axios                                from 'axios';
import constants                            from '@/constants';
import store                                from '@/vuex/store';
import loginService                         from '@/service/skpLoginService';

export default {
    data() {
        return {
            loginId: '',
            loginPwd: '',
            loginSystem: 'WLDPTM',
            loginType: 'F',
            loadMenuKind: '',
            reqPassword: false,
            //add DevMode flag 20260316
            isDevMode: false, 
        };
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            connSystem: 'getConnSystem',
        }),
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        getUserLoginSystem() {
            const loginUser = this.getLoginUser || {};
            return loginUser['loginSystem'] || '';
        },
    },
    methods: {
        ...mapActions(['directLogin', 'logout']),
        async handleSubmit() {
            SDLUtil.showLoadingBar(true);
            // SDLUtil.alert({ msg: 'sdp.currency.exchRate.gdatu' });
            if (SDLUtil.isLocal() && SDLUtil.isNull(this.loginPwd)) {
                this.loginPwd = ' ';
            }
            this.submitted = true;
            const { loginId, loginPwd, loginSystem, loginType, loadMenuKind } = this;

            if (loginId && loginSystem) {
                this.loadMenuKind = loginSystem == 'SUPPORT' ? 'SUP' : 'ALL';
                let loginData = {
                    loginId: this.loginId,
                    loginPwd: this.loginPwd,
                    loginSystem: this.loginSystem,
                    loginType: 'F',
                    loadMenuKind: this.loadMenuKind,
                };
                const loginResult = await this.directLogin(loginData).catch(err => {
                    Vue.$log.error('＃ DirectLogin.vue loginResult error =>', err);
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.alert({
                        title: 'TITLE.WARNING.TITLE',
                        msg: 'MESSAGE.AUTH.PWD.NOTMATCH',
                        okLabel: 'BUTTON.GLOBAL.OK',
                    });
                });
                // if (SDLUtil.IS_DEV_MODE) {
                //     axios.get(`${SDLUtil.API_URL}/basis/approval/handleChangeStatus.skp`);
                // }
                return this.afterLoginProcess(loginResult);
            }
        },
        afterLoginProcess(loginResult = false) {
            SDLUtil.showLoadingBar(false);
            if (loginResult) {
                this.gotoMain();

            } else {
                this.$log.info('afterLoginProcess error');
                return SDLUtil.alert({
                    title: 'TITLE.WARNING.TITLE',
                    msg: 'MESSAGE.AUTH.PWD.NOTMATCH',
                    okLabel: 'BUTTON.GLOBAL.OK',
                });
            }
        },
        gotoMain() {
            const redirect = this.$route.query.r || '';
            if (redirect) {
                Vue.$log.info('＃ DirectLogin.vue redirect => ', redirect);
                this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}` + `${redirect}` });
            } else {
                if (this.loginSystem == 'SUPPORT') {
                    this.$router.push(MenuUtil.getSupportMain());
                } else {
                    this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/main` });
                }
            }
        },
        loginIdChange(e) {
            this.loginId = e.target.value;
            this.loginPwd = "";
        },
        localAutoLogin(v) {
            let result = false;
            if (SDLUtil.isLocal()) {
                if (StringUtil.isNull(v)) {
                    this.loginId = '';
                } else {
                    result = true;
                }
            }
            return result;
        },
    },
    created() {
    	
    	// Read the system mode.
    	//isProd : prod, dev,local
    	const isProd = process.env.NODE_ENV ;
    	//alert(" isProd // "+process.env.NODE_ENV);
        //const systemMode = PropertiesPlugIn.getPropValue("basis.system.mode");
        
        this.isDevMode = (isProd === 'dev' || isProd === 'local');

        // If not dev environments, directly redirect or keep blank.
        if (!this.isDevMode) {
            // Use routing to redirect to the "NoAuth" page.
            //this.$router.replace({ name: 'NoAuth' });
            return;
        }
    	
        if (SDLUtil.isLogin()) {
            this.gotoMain();

        /*
         * 직접 주소 입력으로 접근 시 방지, logout 페이지에서 키입력을 통해야만 접근 가능
        } else if(!SDLUtil.isLogin() && this.connSystem !== 'DIRECT') {
            store.commit('CONN_SYSTEM', '');
            return this.$router.push({ name: 'NoAuth' });
        */
        } else if (this.$route.params.loginId) {
            // Automatically enter the ID you entered when you passed the membership registration
            this.loginId = this.$route.params.loginId;
        }
    },
    mounted() {
        this.localAutoLogin();
    },
    watch: {
        errorState() {
            alert(this.errorState.code);
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/error` });
        },
    },
};
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:300);

.login-page {
    width: 360px;
    padding: 8% 0 0;
    margin: auto;
}
.form {
    position: relative;
    z-index: 1;
    background: #ffffff;
    max-width: 360px;
    margin: 0 auto 100px;
    padding: 45px;
    text-align: center;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}
.form select {
    font-family: 'Roboto', sans-serif;
    outline: 0;
    background: #f2f2f2;
    width: 100%;
    border: 0;
    margin: 0 0 15px;
    height: 47px;
    line-height: normal;
    padding: 15px !important;
    box-sizing: border-box;
    font-size: 14px;
}
.form input {
    font-family: 'Roboto', sans-serif;
    outline: 0;
    background: #f2f2f2;
    width: 100%;
    border: 0;
    margin: 0 0 15px;
    padding: 15px;
    box-sizing: border-box;
    font-size: 14px;
}
.form button {
    font-family: 'Roboto', sans-serif;
    text-transform: uppercase;
    outline: 0;
    background: #28292d;
    width: 100%;
    border: 0;
    padding: 15px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 700;
    -webkit-transition: all 0.3 ease;
    transition: all 0.3 ease;
    cursor: pointer;
}
.form .message {
    margin: 0 0 5px 0;
    color: #b3b3b3;
    font-size: 12px;
}
.form .message a {
    color: #4caf50;
    text-decoration: none;
}
.form button:hover,
.form button:active,
.form button:focus {
    background: #808080;
}
body {
    background: #76b852; /* fallback for old browsers */
    background: -webkit-linear-gradient(right, #76b852, #8dc26f);
    background: -moz-linear-gradient(right, #76b852, #8dc26f);
    background: -o-linear-gradient(right, #76b852, #8dc26f);
    background: linear-gradient(to left, #76b852, #8dc26f);
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

/* 200618추가 */
dl.notice_msg {display:block;margin-bottom:15px;text-align:left;padding-bottom:15px;border-bottom:1px solid #eee;}
dl.notice_msg dt {font-size:14px;color:red;font-weight:bold;}
dl.notice_msg dd {font-size:14px;line-height:20px;padding-top:5px;}
dl.notice_msg dd span {font-weight: bold;}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/login/DirectLogin.vue